exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Slider-module-cursor_54qNM {\n  position: absolute;\n  border-radius: 50%;\n  box-sizing: border-box;\n  cursor: move;\n}\n", ""]);

// exports
exports.locals = {
	"cursor": "Slider-module-cursor_54qNM"
};